var Vendd = (function (Vendd) {
    'use strict';

    Vendd.User = (function (User) {

        User.AuthProviders = (function (AuthProviders) {

            var dq = {

                connect: function (loginId, email, onSuccess, onError) {
                    Vendd.Service.call({
                        url: 'AuthService.svc/ConnectAuthenticationProvider',
                        data: {
                            provider: 'disqus',
                            loginId: loginId,
                            email: email
                        },
                        onSuccess: onSuccess,
                        onFailure: onError
                    });
                }
            };

            AuthProviders.disqus = {

                initiating: false,
                initiated: false,

                Configuration: {
                    ClientId: '',
                    AuthUrl: '',
                    ShortName: ''
                },

                init: function (source, identifier, url) {
                    var me = this;

                    if (!this.initiating && !this.initiated) {
                        this.initiating = true;

                        Vendd.Service.call({
                            url: 'Auth/DisqusService.svc/GetConfiguration',
                            data: {},
                            onSuccess: function (res) {

                                me.Configuration.ClientId = res.clientId;
                                me.Configuration.AuthUrl = res.authUrl;
                                me.Configuration.ShortName = res.shortName;

                                var d = document, s = d.createElement('script');
                                
                                s.src = '//' + me.Configuration.ShortName + '.disqus.com/embed.js';

                                s.setAttribute('data-timestamp', +new Date());
                                (d.head || d.body).appendChild(s);

                                me.initiated = true;
                            },
                            onFailure: function (ex) {
                                throw ex;
                            }
                        });                        
                    }
                }

            };

            return AuthProviders;

        })(User.AuthProviders || {});

        return User;

    })(Vendd.User || {});

    return Vendd;

})(Vendd || {});